import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Link from '../../app/components/link';
import Slider from '../../app/components/slider';
import Lead from '../../Lead';
import image1 from '../../app/data/screenshots/macau/home2.jpg';
import image2 from '../../app/data/screenshots/macau/news_economy.jpg';
import image3 from '../../app/data/screenshots/macau/news_people.jpg';
import image4 from '../../app/data/screenshots/macau/videos.jpg';

const images = [
  {
    src: image1,
    alt: 'Macau News home page',
  },
  {
    src: image2,
    alt: 'Macau News category page - economy',
  },
  {
    src: image4,
    alt: 'Macau News videos page',
  },
  {
    src: image3,
    alt: 'Macau News category page - people',
  },
];

const tags = [
  'Blog',
  'Design',
  'Wordpress',
  'Javascript',
  'CSS',
];

export default () => (
  <div>
    <Details
      title="Macau News"
      subtitle="Media"
    >
      <Details.Paragraph emoji="🇲🇴" title="A leading media company in Macau">
        <Link target="_blank" href="https://macaunews.mo/">Macau News</Link> is a leading local
        media publisher, that reports on the latest news in Macau. They focus on publishing
        original content and covering key stories and events happening in the city of Macau.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="Back to basics">
        Macau News wanted a website that allows them to deliver news as efficient as
        possible. They needed it to be simple; stripped to the essentials of publishing stories and
        media. Our approach adheres to well-established patterns in website and UI design, and is
        sync with the readers expectations. The end result is a clean and easy to navigate blog,
        that is focused on the content.
      </Details.Paragraph>
      <Details.Tags tags={tags} />
      <Slider images={images} />
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/macau-news.js